<body>
    <div class="container">
        <div class="row">
            <div class="col-sm-9">
                <!-- <div id="Logo"></div> -->
                <span id="headerText">Plant Place Store</span>
            </div>
            <div class="col-sm-3">
              <div class="pull-right" style="margin-top:10px;display:flex">
                <mat-icon style="color:gray;">info</mat-icon>
                <small>Use the Item code to buy item(s).</small>
              </div>
                <!-- <mat-form-field appearance="fill" class="pull-right">
                <mat-label>Select Category</mat-label>
                <mat-select>
                    <mat-option value="OP">Ornamental Plants</mat-option>
                    <mat-option value="TP">Tropical Plants</mat-option>
                    <mat-option value="IP">Indoor Plants</mat-option>
                    <mat-option value="HP">Hanging Plants</mat-option>
                    <mat-option value="HS">Herbs & Spices</mat-option>
                </mat-select>
                </mat-form-field> -->
            </div>
        </div>
        <hr><br>
        <div class="row">
            <div class="col-sm-4">
                <mat-card class="example-card">
                    <mat-card-header>
                      <!-- <div mat-card-avatar class="example-header-image"></div> -->
                      <mat-card-title><h4>Palmera</h4></mat-card-title>
                      <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
                    </mat-card-header>
                    <img mat-card-image src="assets/on-the-shop/palmera001.jpg">
                    <mat-card-content>
                      <table>
                        <tr>
                          <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
                          <td width="65%"><span> <h6><b>PALMERA001</b></h6> </span></td>
                          <td width="35%">
                            <p><span class="badge-limited">Limited Stocks</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
                          <td><span> <h6><b>450.00</b></h6> </span></td>
                        </tr>
                        <tr>
                          <td><span>Benefits:</span></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td><mat-icon class="c-success">done</mat-icon></td>
                          <td colspan="2"><span>Natural air cooler.</span></td>
                        </tr>
                        <tr>
                          <td><mat-icon class="c-success">done</mat-icon></td>
                          <td colspan="2"><span>Improves air quality.</span></td>
                        </tr>
                        <tr>
                          <td><mat-icon class="c-success">done</mat-icon></td>
                          <td colspan="2"><span>Ideal Houseplant.</span></td>
                        </tr>
                        <tr>
                          <td><mat-icon class="c-success">done</mat-icon></td>
                          <td colspan="2"><span>Safe for pets.</span></td>
                        </tr>
                      </table>
                    </mat-card-content>
                    <mat-accordion style="border:none;box-shadow: none;">
                      <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                        </mat-panel-title>
                        <mat-panel-description>
                          <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon> 
                          <span>Plant Care Tips!</span>
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <div style="display:flex">
                        <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                        <span style="font-weight:bold">SOIL</span>
                      </div>
                        This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
                        <div style="display:flex">
                          <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                          <span style="font-weight:bold">SUNLIGHT</span>
                        </div>
                        Palms can resists in full sunlight but too much exposure might cause drying of leaves. It is 
                        recommended to put it in indirect sunlight or bright sunlight to maintain its fresh leaves.<br><hr>
                        <div style="display:flex">
                          <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                          <span style="font-weight:bold">WATER</span>
                        </div>
                        Water only when the topmost soil is dry, Also do misting of water as needed to remove dirts.
                    </mat-expansion-panel>
                  </mat-accordion>
                    <!-- <mat-card-actions>
                      <button mat-button>LIKE</button>
                      <button mat-button>SHARE</button>
                    </mat-card-actions> -->
                  </mat-card>
            </div>
            <div class="col-sm-4">
                <mat-card class="example-card">
                    <mat-card-header>
                      <!-- <div mat-card-avatar class="example-header-image"></div> -->
                      <mat-card-title><h4>Peruvian Fern</h4></mat-card-title>
                      <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
                    </mat-card-header>
                    <img mat-card-image src="assets/on-the-shop/peruvian001.jpg">
                    <mat-card-content>
                      <table>
                        <tr>
                          <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
                          <td width="65%"><span> <h6><b>PERUVIAN001</b></h6> </span></td>
                          <td width="35%">
                            <p><span class="badge-limited">Limited Stocks</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
                          <td><span> <h6><b>500.00</b></h6> </span></td>
                        </tr>
                        <tr>
                          <td><span>Benefits:</span></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td><mat-icon class="c-success">done</mat-icon></td>
                          <td colspan="2"><span>Natural air purifier.</span></td>
                        </tr>
                        <tr>
                          <td><mat-icon class="c-success">done</mat-icon></td>
                          <td colspan="2"><span>Improves air quality.</span></td>
                        </tr>
                        <tr>
                          <td><mat-icon class="c-success">done</mat-icon></td>
                          <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
                        </tr>
                        <tr>
                          <td><mat-icon class="c-success">done</mat-icon></td>
                          <td colspan="2"><span>Safe for pets.</span></td>
                        </tr>
                      </table>
                    </mat-card-content>
                    <mat-accordion style="border:none;box-shadow: none;">
                      <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                        </mat-panel-title>
                        <mat-panel-description>
                          <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
                          <span>Plant Care Tips!</span>
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <div style="display:flex">
                        <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                        <span style="font-weight:bold">SOIL</span>
                      </div>
                        Recommended to use Coco peat with Vermicast as soil mix for different kinds of ferns.<br><hr>
                        <div style="display:flex">
                          <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                          <span style="font-weight:bold">SUNLIGHT</span>
                        </div>
                        Ideal sunlight exposure for different kinds of ferns is between 07:00 AM to 10:00 AM to grow healthier with lush green leaves.<br><hr>
                        <div style="display:flex">
                          <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                          <span style="font-weight:bold">WATER</span>
                        </div>
                        Water at least once a week, Also do misting of water as needed to remove dirts.
                    </mat-expansion-panel>
                  </mat-accordion>
                    <!-- <mat-card-actions>
                      <button mat-button>LIKE</button>
                      <button mat-button>SHARE</button>
                    </mat-card-actions> -->
                  </mat-card>
            </div>
            <div class="col-sm-4">
                <mat-card class="example-card">
                    <mat-card-header>
                      <!-- <div mat-card-avatar class="example-header-image"></div> -->
                      <mat-card-title><h4>Golden Cane Palm</h4></mat-card-title>
                      <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
                    </mat-card-header>
                    <img mat-card-image src="assets/on-the-shop/goldencane001.jpg">
                    <mat-card-content>
                      <table>
                        <tr>
                          <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
                          <td width="65%"><span> <h6><b>GOLDENCN001</b></h6> </span></td>
                          <td width="35%">
                            <p><span class="badge-limited">Limited Stocks</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
                          <td><span> <h6><b>350.00</b></h6> </span></td>
                        </tr>
                        <tr>
                          <td><span>Benefits:</span></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td><mat-icon class="c-success">done</mat-icon></td>
                          <td colspan="2"><span>Natural air cooler.</span></td>
                        </tr>
                        <tr>
                          <td><mat-icon class="c-success">done</mat-icon></td>
                          <td colspan="2"><span>Improves air quality.</span></td>
                        </tr>
                        <tr>
                          <td><mat-icon class="c-success">done</mat-icon></td>
                          <td colspan="2"><span>Ideal Houseplant.</span></td>
                        </tr>
                        <tr>
                          <td><mat-icon class="c-success">done</mat-icon></td>
                          <td colspan="2"><span>Safe for pets.</span></td>
                        </tr>
                      </table>
                    </mat-card-content>
                    <mat-accordion style="border:none;box-shadow: none;">
                      <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                        </mat-panel-title>
                        <mat-panel-description>
                          <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
                          <span>Plant Care Tips!</span>
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      <div style="display:flex">
                        <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                        <span style="font-weight:bold">SOIL</span>
                      </div>
                        This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
                        <div style="display:flex">
                          <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                          <span style="font-weight:bold">SUNLIGHT</span>
                        </div>
                        Palms can resists in full sunlight but too much exposure might cause drying of leaves. It is 
                        recommended to put it in indirect sunlight or bright sunlight to maintain its fresh leaves.<br><hr>
                        <div style="display:flex">
                          <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                          <span style="font-weight:bold">WATER</span>
                        </div>
                        Water only when the topmost soil is dry, Also do misting of water as needed to remove dirts.
                    </mat-expansion-panel>
                  </mat-accordion>
                    <!-- <mat-card-actions>
                      <button mat-button>LIKE</button>
                      <button mat-button>SHARE</button>
                    </mat-card-actions> -->
                  </mat-card>
            </div>
        </div>
        <div class="row p-t-30">
          <div class="col-sm-4">
              <mat-card class="example-card">
                  <mat-card-header>
                    <!-- <div mat-card-avatar class="example-header-image"></div> -->
                    <mat-card-title><h4>Golden Cane Palm</h4></mat-card-title>
                    <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
                  </mat-card-header>
                  <img mat-card-image src="assets/on-the-shop/goldencane002.jpg">
                  <mat-card-content>
                    <table>
                      <tr>
                        <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
                        <td width="65%"><span> <h6><b>GOLDENCN002</b></h6> </span></td>
                        <td width="35%">
                            <p><span class="badge-limited">Limited Stocks</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
                        <td><span> <h6><b>350.00</b></h6> </span></td>
                      </tr>
                      <tr>
                        <td><span>Benefits:</span></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><mat-icon class="c-success">done</mat-icon></td>
                        <td colspan="2"><span>Natural air cooler.</span></td>
                      </tr>
                      <tr>
                        <td><mat-icon class="c-success">done</mat-icon></td>
                        <td colspan="2"><span>Improves air quality.</span></td>
                      </tr>
                      <tr>
                        <td><mat-icon class="c-success">done</mat-icon></td>
                        <td colspan="2"><span>Ideal Houseplant.</span></td>
                      </tr>
                      <tr>
                        <td><mat-icon class="c-success">done</mat-icon></td>
                        <td colspan="2"><span>Safe for pets.</span></td>
                      </tr>
                    </table>
                  </mat-card-content>
                  <mat-accordion style="border:none;box-shadow: none;">
                    <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                      </mat-panel-title>
                      <mat-panel-description>
                        <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
                        <span>Plant Care Tips!</span>
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div style="display:flex">
                      <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                      <span style="font-weight:bold">SOIL</span>
                    </div>
                      This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
                      <div style="display:flex">
                        <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                        <span style="font-weight:bold">SUNLIGHT</span>
                      </div>
                      Palms can resists in full sunlight but too much exposure might cause drying of leaves. It is 
                      recommended to put it in indirect sunlight or bright sunlight to maintain its fresh leaves.<br><hr>
                      <div style="display:flex">
                        <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                        <span style="font-weight:bold">WATER</span>
                      </div>
                      Water only when the topmost soil is dry, Also do misting of water as needed to remove dirts.
                  </mat-expansion-panel>
                </mat-accordion>
                  <!-- <mat-card-actions>
                    <button mat-button>LIKE</button>
                    <button mat-button>SHARE</button>
                  </mat-card-actions> -->
                </mat-card>
                
          </div>
          <div class="col-sm-4">
              <mat-card class="example-card">
                  <mat-card-header>
                    <!-- <div mat-card-avatar class="example-header-image"></div> -->
                    <mat-card-title><h4>Golden Crinum Lily</h4></mat-card-title>
                    <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
                  </mat-card-header>
                  <img mat-card-image src="assets/on-the-shop/crinum002.jpg">
                  <mat-card-content>
                    <table>
                      <tr>
                        <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
                        <td width="65%"><span> <h6><b>CRINUM002</b></h6> </span></td>
                        <td width="35%">
                          <p><span class="badge-stock">3⁺ Items available</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
                        <td><span> <h6><b>200.00</b></h6> </span></td>
                      </tr>
                      <tr>
                        <td><span>Benefits:</span></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><mat-icon class="c-success">done</mat-icon></td>
                        <td colspan="2"><span>Flowering plant.</span></td>
                      </tr>
                      <tr>
                        <td><mat-icon class="c-success">done</mat-icon></td>
                        <td colspan="2"><span>Plant for fence.</span></td>
                      </tr>
                      <tr>
                        <td><mat-icon class="c-success">done</mat-icon></td>
                        <td colspan="2"><span>For lanscaping use.</span></td>
                      </tr>
                      <tr>
                        <td><mat-icon class="c-error">clear</mat-icon></td>
                        <td colspan="2"><span>Keep away from pets.</span></td>
                      </tr>
                    </table>
                  </mat-card-content>
                  <mat-accordion style="border:none;box-shadow: none;">
                    <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                      </mat-panel-title>
                      <mat-panel-description>
                        <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
                        <span>Plant Care Tips!</span>
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div style="display:flex">
                      <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                      <span style="font-weight:bold">SOIL</span>
                    </div>
                      This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
                      <div style="display:flex">
                        <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                        <span style="font-weight:bold">SUNLIGHT</span>
                      </div>
                      Golden Crinum lily wants full sunlight to turns its leaves into golden yellow. However, 
                      Brings it indoors will maintain its fresh green leaves.
                      <br><hr>
                      <div style="display:flex">
                        <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                        <span style="font-weight:bold">WATER</span>
                      </div>
                      Water only when the topmost soil is dry, Also do misting of water as needed to remove dirts.
                  </mat-expansion-panel>
                </mat-accordion>
                  <!-- <mat-card-actions>
                    <button mat-button>LIKE</button>
                    <button mat-button>SHARE</button>
                  </mat-card-actions> -->
                </mat-card>
          </div>
          <div class="col-sm-4">
              <mat-card class="example-card">
                  <mat-card-header>
                    <!-- <div mat-card-avatar class="example-header-image"></div> -->
                    <mat-card-title><h4>Golden Crinum Lily</h4></mat-card-title>
                    <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
                  </mat-card-header>
                  <img mat-card-image src="assets/on-the-shop/crinum001.jpg">
                  <mat-card-content>
                    <table>
                      <tr>
                        <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
                        <td width="65%"><span> <h6><b>CRINUM001</b></h6> </span></td>
                        <td width="35%">
                          <p><span class="badge-stock">3⁺ Items available</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
                        <td><span> <h6><b>200.00</b></h6> </span></td>
                      </tr>
                      <tr>
                        <td><span>Benefits:</span></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><mat-icon class="c-success">done</mat-icon></td>
                        <td colspan="2"><span>Flowering plant.</span></td>
                      </tr>
                      <tr>
                        <td><mat-icon class="c-success">done</mat-icon></td>
                        <td colspan="2"><span>Plant for fence.</span></td>
                      </tr>
                      <tr>
                        <td><mat-icon class="c-success">done</mat-icon></td>
                        <td colspan="2"><span>For lanscaping use.</span></td>
                      </tr>
                      <tr>
                        <td><mat-icon class="c-error">clear</mat-icon></td>
                        <td colspan="2"><span>Keep away from pets.</span></td>
                      </tr>
                    </table>
                  </mat-card-content>
                  <mat-accordion style="border:none;box-shadow: none;">
                    <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                      </mat-panel-title>
                      <mat-panel-description>
                        <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
                        <span>Plant Care Tips!</span>
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    <div style="display:flex">
                      <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                      <span style="font-weight:bold">SOIL</span>
                    </div>
                      This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
                      <div style="display:flex">
                        <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                        <span style="font-weight:bold">SUNLIGHT</span>
                      </div>
                      Golden Crinum lily wants full sunlight to turns its leaves into golden yellow. However, 
                      Brings it indoors will maintain its fresh green leaves.
                      <br><hr>
                      <div style="display:flex">
                        <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                        <span style="font-weight:bold">WATER</span>
                      </div>
                      Water only when the topmost soil is dry, Also do misting of water as needed to remove dirts.
                  </mat-expansion-panel>
                </mat-accordion>
                  <!-- <mat-card-actions>
                    <button mat-button>LIKE</button>
                    <button mat-button>SHARE</button>
                  </mat-card-actions> -->
                </mat-card>
          </div>
      </div>
      <div class="row p-t-30">
          <div class="col-sm-4">
            <mat-card class="example-card">
                <mat-card-header>
                  <!-- <div mat-card-avatar class="example-header-image"></div> -->
                  <mat-card-title><h4>Golden Crinum Lily</h4></mat-card-title>
                  <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
                </mat-card-header>
                <img mat-card-image src="assets/on-the-shop/crinum003.jpg">
                <mat-card-content>
                  <table>
                    <tr>
                      <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
                      <td width="65%"><span> <h6><b>CRINUM003</b></h6> </span></td>
                      <td width="35%">
                        <p><span class="badge-stock">30⁺ Items available</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
                      <td><span> <h6><b>50.00</b></h6> </span></td>
                    </tr>
                    <tr>
                      <td><span>Benefits:</span></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>Flowering plant.</span></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>Plant for fence.</span></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>For lanscaping use.</span></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-error">clear</mat-icon></td>
                      <td colspan="2"><span>Keep away from pets.</span></td>
                    </tr>
                  </table>
                </mat-card-content>
                <mat-accordion style="border:none;box-shadow: none;">
                  <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                    </mat-panel-title>
                    <mat-panel-description>
                      <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
                      <span>Plant Care Tips!</span>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div style="display:flex">
                    <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                    <span style="font-weight:bold">SOIL</span>
                  </div>
                    This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
                    <div style="display:flex">
                      <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                      <span style="font-weight:bold">SUNLIGHT</span>
                    </div>
                    Golden Crinum lily wants full sunlight to turns its leaves into golden yellow. However, 
                    Brings it indoors will maintain its fresh green leaves.
                    <br><hr>
                    <div style="display:flex">
                      <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                      <span style="font-weight:bold">WATER</span>
                    </div>
                    Water only when the topmost soil is dry, Also do misting of water as needed to remove dirts.
                </mat-expansion-panel>
              </mat-accordion>
                <!-- <mat-card-actions>
                  <button mat-button>LIKE</button>
                  <button mat-button>SHARE</button>
                </mat-card-actions> -->
              </mat-card>
        </div>
        <div class="col-sm-4">
            <mat-card class="example-card">
                <mat-card-header>
                  <!-- <div mat-card-avatar class="example-header-image"></div> -->
                  <mat-card-title><h4>Heliconia Rostrata</h4></mat-card-title>
                  <mat-card-subtitle><h6>Tropical Plant</h6></mat-card-subtitle>
                </mat-card-header>
                <img mat-card-image src="assets/on-the-shop/rostrata.jpg">
                <mat-card-content>
                  <table>
                    <tr>
                      <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
                      <td width="65%"><span> <h6><b>ROSTRATA001</b></h6> </span></td>
                      <td width="35%">
                        <p><span class="badge-stock">10⁺ Items available</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
                      <td><span> <h6><b>150.00</b></h6> </span></td>
                    </tr>
                    <tr>
                      <td><span>Benefits:</span></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>Natural air cooler.</span></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>Flowering plant.</span></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>For tropical or jungle inspired garden.</span></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-error">clear</mat-icon></td>
                      <td colspan="2"><span>Keep away from pets.</span></td>
                    </tr>
                  </table>
                </mat-card-content>
                <mat-accordion style="border:none;box-shadow: none;">
                  <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                    </mat-panel-title>
                    <mat-panel-description>
                      <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
                      <span>Plant Care Tips!</span>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div style="display:flex">
                    <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                    <span style="font-weight:bold">SOIL</span>
                  </div>
                    This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
                    <div style="display:flex">
                      <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                      <span style="font-weight:bold">SUNLIGHT</span>
                    </div>
                    You can place it to indirect sunlight part of your home. too much sun exposure might cause its leaves become droopy 
                    and colored yellow.
                    <br><hr>
                    <div style="display:flex">
                      <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                      <span style="font-weight:bold">WATER</span>
                    </div>
                    Water at least twice a week, Also do misting of water as needed to remove dirts.
                </mat-expansion-panel>
              </mat-accordion>
                <!-- <mat-card-actions>
                  <button mat-button>LIKE</button>
                  <button mat-button>SHARE</button>
                </mat-card-actions> -->
              </mat-card>
        </div>
        <div class="col-sm-4">
            <mat-card class="example-card">
                <mat-card-header>
                  <!-- <div mat-card-avatar class="example-header-image"></div> -->
                  <mat-card-title><h4>Philodendron Orlando</h4></mat-card-title>
                  <mat-card-subtitle><h6>Indoor Plant</h6></mat-card-subtitle>
                </mat-card-header>
                <img mat-card-image src="assets/on-the-shop/orlando.jpg">
                <mat-card-content>
                  <table>
                    <tr>
                      <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
                      <td width="65%"><span> <h6><b>ORLANDO001</b></h6> </span></td>
                      <td width="35%">
                        <p><span class="badge-limited">Limited Stocks</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
                      <td><span> <h6><b>100.00</b></h6> </span></td>
                    </tr>
                    <tr>
                      <td><span>Benefits:</span></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>Improves air quality.</span></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
                    </tr>
                     <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>Ideal Houseplant.</span></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-error">clear</mat-icon></td>
                      <td colspan="2"><span>Keep away from pets.</span></td>
                    </tr>
                  </table>
                </mat-card-content>
                <mat-accordion style="border:none;box-shadow: none;">
                  <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                    </mat-panel-title>
                    <mat-panel-description>
                      <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
                      <span>Plant Care Tips!</span>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div style="display:flex">
                    <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                    <span style="font-weight:bold">SOIL</span>
                  </div>
                    This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
                    <div style="display:flex">
                      <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                      <span style="font-weight:bold">SUNLIGHT</span>
                    </div>
                    Philodendron Orlando can grow indoors and outdoors but indirect sunlight. to maintain its lively leaves.
                    <br><hr>
                    <div style="display:flex">
                      <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                      <span style="font-weight:bold">WATER</span>
                    </div>
                    Water only when the topmost soil is dry, Also do misting of water as needed to remove dirts.
                </mat-expansion-panel>
              </mat-accordion>
                <!-- <mat-card-actions>
                  <button mat-button>LIKE</button>
                  <button mat-button>SHARE</button>
                </mat-card-actions> -->
              </mat-card>
        </div>
    </div>
     <div class="row p-t-30">
          <div class="col-sm-4">
            <mat-card class="example-card">
                <mat-card-header>
                  <!-- <div mat-card-avatar class="example-header-image"></div> -->
                  <mat-card-title><h4>Golden Pothos</h4></mat-card-title>
                  <mat-card-subtitle><h6>Indoor Plant</h6></mat-card-subtitle>
                </mat-card-header>
                <img mat-card-image src="assets/on-the-shop/pothos001.jpg">
                <mat-card-content>
                  <table>
                    <tr>
                      <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
                      <td width="65%"><span> <h6><b>POTHOS001</b></h6> </span></td>
                      <td width="35%">
                        <p><span class="badge-stock">10⁺ Items available</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
                      <td><span> <h6><b>50.00</b></h6> </span></td>
                    </tr>
                    <tr>
                      <td><span>Benefits:</span></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>Natural air cooler.</span></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>Improves air quality.</span></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>For tropical or jungle inspired garden.</span></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-error">clear</mat-icon></td>
                      <td colspan="2"><span>Keep away from pets.</span></td>
                    </tr>
                  </table>
                </mat-card-content>
                <mat-accordion style="border:none;box-shadow: none;">
                  <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                    </mat-panel-title>
                    <mat-panel-description>
                      <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
                      <span>Plant Care Tips!</span>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div style="display:flex">
                    <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                    <span style="font-weight:bold">SOIL</span>
                  </div>
                    This plant can grow in different kinds of soil but make sure you will use a well drained soil. It can Also
                    grow in water just submerge the stem with roots in water.<br><hr>
                    <div style="display:flex">
                      <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                      <span style="font-weight:bold">SUNLIGHT</span>
                    </div>
                    Golden pothos can grow in minimal sunlight you can even put it in bedroom or restroom but bring it to
                    sunlight every other day.
                    <br><hr>
                    <div style="display:flex">
                      <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                      <span style="font-weight:bold">WATER</span>
                    </div>
                    Golden pothos wants moist to wet soil to maintain its alive and green leaves, lacks of water might cause drooping of leaves,
                    Also do misting of water as needed to remove dirts.
                </mat-expansion-panel>
              </mat-accordion>
                <!-- <mat-card-actions>
                  <button mat-button>LIKE</button>
                  <button mat-button>SHARE</button>
                </mat-card-actions> -->
              </mat-card>
        </div>
        <div class="col-sm-4">
            <mat-card class="example-card">
                <mat-card-header>
                  <!-- <div mat-card-avatar class="example-header-image"></div> -->
                  <mat-card-title><h4>Fishtail Fern</h4></mat-card-title>
                  <mat-card-subtitle><h6>Indoor Plant</h6></mat-card-subtitle>
                </mat-card-header>
                <img mat-card-image src="assets/on-the-shop/fishtail001.jpg">
                <mat-card-content>
                  <table>
                    <tr>
                      <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
                      <td width="65%"><span> <h6><b>FISHTAIL001</b></h6> </span></td>
                      <td width="35%">
                        <p><span class="badge-limited">Limited Stocks</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
                      <td><span> <h6><b>400.00</b></h6> </span></td>
                    </tr>
                    <tr>
                      <td><span>Benefits:</span></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>Natural air purifier.</span></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>Improves air quality.</span></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>Safe for pets.</span></td>
                    </tr>
                  </table>
                </mat-card-content>
                <mat-accordion style="border:none;box-shadow: none;">
                  <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                    </mat-panel-title>
                    <mat-panel-description>
                      <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
                      <span>Plant Care Tips!</span>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div style="display:flex">
                    <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                    <span style="font-weight:bold">SOIL</span>
                  </div>
                  Recommended to use Coco peat with Vermicast as soil mix for different kinds of ferns.<br><hr>
                  <div style="display:flex">
                    <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                    <span style="font-weight:bold">SUNLIGHT</span>
                  </div>
                  Ideal sunlight exposure for different kinds of ferns is between 07:00 AM to 10:00 AM to grow healthier with lush green leaves.<br><hr>
                  <div style="display:flex">
                    <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                    <span style="font-weight:bold">WATER</span>
                  </div>
                  Water at least once a week, Also do misting of water as needed to remove dirts.
                </mat-expansion-panel>
              </mat-accordion>
                <!-- <mat-card-actions>
                  <button mat-button>LIKE</button>
                  <button mat-button>SHARE</button>
                </mat-card-actions> -->
              </mat-card>
        </div>
        <div class="col-sm-4">
            <mat-card class="example-card">
                <mat-card-header>
                  <!-- <div mat-card-avatar class="example-header-image"></div> -->
                  <mat-card-title><h4>Fishtail Fern</h4></mat-card-title>
                  <mat-card-subtitle><h6>Indoor Plant</h6></mat-card-subtitle>
                </mat-card-header>
                <img mat-card-image src="assets/on-the-shop/fishtail002.jpg">
                <mat-card-content>
                  <table>
                    <tr>
                      <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
                      <td width="65%"><span> <h6><b>FISHTAIL002</b></h6> </span></td>
                      <td width="35%">
                        <p><span class="badge-limited">Limited Stocks</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
                      <td><span> <h6><b>400.00</b></h6> </span></td>
                    </tr>
                    <tr>
                      <td><span>Benefits:</span></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>Natural air purifier.</span></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>Improves air quality.</span></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
                    </tr>
                    <tr>
                      <td><mat-icon class="c-success">done</mat-icon></td>
                      <td colspan="2"><span>Safe for pets.</span></td>
                    </tr>
                  </table>
                </mat-card-content>
                <mat-accordion style="border:none;box-shadow: none;">
                  <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                    </mat-panel-title>
                    <mat-panel-description>
                      <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
                      <span>Plant Care Tips!</span>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div style="display:flex">
                    <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                    <span style="font-weight:bold">SOIL</span>
                  </div>
                  Recommended to use Coco peat with Vermicast as soil mix for different kinds of ferns.<br><hr>
                  <div style="display:flex">
                    <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                    <span style="font-weight:bold">SUNLIGHT</span>
                  </div>
                  Ideal sunlight exposure for different kinds of ferns is between 07:00 AM to 10:00 AM to grow healthier with lush green leaves.<br><hr>
                  <div style="display:flex">
                    <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                    <span style="font-weight:bold">WATER</span>
                  </div>
                  Water at least once a week, Also do misting of water as needed to remove dirts.
                </mat-expansion-panel>
              </mat-accordion>
                <!-- <mat-card-actions>
                  <button mat-button>LIKE</button>
                  <button mat-button>SHARE</button>
                </mat-card-actions> -->
              </mat-card>
        </div>
    </div>
    <div class="row p-t-30">
      <div class="col-sm-4">
        <mat-card class="example-card">
            <mat-card-header>
              <!-- <div mat-card-avatar class="example-header-image"></div> -->
              <mat-card-title><h4>Peruvian Fern</h4></mat-card-title>
              <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
            </mat-card-header>
            <img mat-card-image src="assets/on-the-shop/peruvian002.jpg">
            <mat-card-content>
              <table>
                <tr>
                  <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
                  <td width="65%"><span> <h6><b>PERUVIAN002</b></h6> </span></td>
                  <td width="35%">
                    <p><span class="badge-limited">Limited Stocks</span></p>
                  </td>
                </tr>
                <tr>
                  <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
                  <td><span> <h6><b>350.00</b></h6> </span></td>
                </tr>
                <tr>
                  <td><span>Benefits:</span></td>
                  <td></td>
                </tr>
                <tr>
                  <td><mat-icon class="c-success">done</mat-icon></td>
                  <td colspan="2"><span>Natural air purifier.</span></td>
                </tr>
                <tr>
                  <td><mat-icon class="c-success">done</mat-icon></td>
                  <td colspan="2"><span>Improves air quality.</span></td>
                </tr>
                <tr>
                  <td><mat-icon class="c-success">done</mat-icon></td>
                  <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
                </tr>
                <tr>
                  <td><mat-icon class="c-success">done</mat-icon></td>
                  <td colspan="2"><span>Safe for pets.</span></td>
                </tr>
              </table>
            </mat-card-content>
            <mat-accordion style="border:none;box-shadow: none;">
              <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                </mat-panel-title>
                <mat-panel-description>
                  <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
                  <span>Plant Care Tips!</span>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div style="display:flex">
                <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                <span style="font-weight:bold">SOIL</span>
              </div>
              Recommended to use Coco peat with Vermicast as soil mix for different kinds of ferns.<br><hr>
              <div style="display:flex">
                <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                <span style="font-weight:bold">SUNLIGHT</span>
              </div>
              Ideal sunlight exposure for different kinds of ferns is between 07:00 AM to 10:00 AM to grow healthier with lush green leaves.<br><hr>
              <div style="display:flex">
                <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                <span style="font-weight:bold">WATER</span>
              </div>
              Water at least once a week, Also do misting of water as needed to remove dirts.
            </mat-expansion-panel>
          </mat-accordion>
            <!-- <mat-card-actions>
              <button mat-button>LIKE</button>
              <button mat-button>SHARE</button>
            </mat-card-actions> -->
          </mat-card>
    </div>
    <div class="col-sm-4">
        <mat-card class="example-card">
            <mat-card-header>
              <!-- <div mat-card-avatar class="example-header-image"></div> -->
              <mat-card-title><h4>Peruvian Fern</h4></mat-card-title>
              <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
            </mat-card-header>
            <img mat-card-image src="assets/on-the-shop/peruvian003.jpg">
            <mat-card-content>
              <table>
                <tr>
                  <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
                  <td width="65%"><span> <h6><b>PERUVIAN003</b></h6> </span></td>
                  <td width="35%">
                    <p><span class="badge-limited">Limited Stocks</span></p>
                  </td>
                </tr>
                <tr>
                  <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
                  <td><span> <h6><b>350.00</b></h6> </span></td>
                </tr>
                <tr>
                  <td><span>Benefits:</span></td>
                  <td></td>
                </tr>
                <tr>
                  <td><mat-icon class="c-success">done</mat-icon></td>
                  <td colspan="2"><span>Natural air purifier.</span></td>
                </tr>
                <tr>
                  <td><mat-icon class="c-success">done</mat-icon></td>
                  <td colspan="2"><span>Improves air quality.</span></td>
                </tr>
                <tr>
                  <td><mat-icon class="c-success">done</mat-icon></td>
                  <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
                </tr>
                <tr>
                  <td><mat-icon class="c-success">done</mat-icon></td>
                  <td colspan="2"><span>Safe for pets.</span></td>
                </tr>
              </table>
            </mat-card-content>
            <mat-accordion style="border:none;box-shadow: none;">
              <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                </mat-panel-title>
                <mat-panel-description>
                  <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
                  <span>Plant Care Tips!</span>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div style="display:flex">
                <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                <span style="font-weight:bold">SOIL</span>
              </div>
              Recommended to use Coco peat with Vermicast as soil mix for different kinds of ferns.<br><hr>
              <div style="display:flex">
                <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                <span style="font-weight:bold">SUNLIGHT</span>
              </div>
              Ideal sunlight exposure for different kinds of ferns is between 07:00 AM to 10:00 AM to grow healthier with lush green leaves.<br><hr>
              <div style="display:flex">
                <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
                <span style="font-weight:bold">WATER</span>
              </div>
              Water at least once a week, Also do misting of water as needed to remove dirts.
            </mat-expansion-panel>
          </mat-accordion>
            <!-- <mat-card-actions>
              <button mat-button>LIKE</button>
              <button mat-button>SHARE</button>
            </mat-card-actions> -->
          </mat-card>
    </div>
    <div class="col-sm-4">
      <mat-card class="example-card">
          <mat-card-header>
            <!-- <div mat-card-avatar class="example-header-image"></div> -->
            <mat-card-title><h4>Golden Cane Palm</h4></mat-card-title>
            <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
          </mat-card-header>
          <img mat-card-image src="assets/on-the-shop/goldencane003.jpg">
          <mat-card-content>
            <table>
              <tr>
                <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
                <td width="65%"><span> <h6><b>GOLDENCN003</b></h6> </span></td>
                <td width="35%">
                  <p><span class="badge-limited">Limited Stocks</span></p>
                </td>
              </tr>
              <tr>
                <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
                <td><span> <h6><b>750.00</b></h6> </span></td>
              </tr>
              <tr>
                <td><span>Benefits:</span></td>
                <td></td>
              </tr>
              <tr>
                <td><mat-icon class="c-success">done</mat-icon></td>
                <td colspan="2"><span>Natural air cooler.</span></td>
              </tr>
              <tr>
                <td><mat-icon class="c-success">done</mat-icon></td>
                <td colspan="2"><span>Improves air quality.</span></td>
              </tr>
              <tr>
                <td><mat-icon class="c-success">done</mat-icon></td>
                <td colspan="2"><span>Ideal Houseplant.</span></td>
              </tr>
              <tr>
                <td><mat-icon class="c-success">done</mat-icon></td>
                <td colspan="2"><span>Safe for pets.</span></td>
              </tr>
            </table>
          </mat-card-content>
          <mat-accordion style="border:none;box-shadow: none;">
            <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
              </mat-panel-title>
              <mat-panel-description>
                <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
                <span>Plant Care Tips!</span>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div style="display:flex">
              <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
              <span style="font-weight:bold">SOIL</span>
            </div>
            This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
            <div style="display:flex">
              <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
              <span style="font-weight:bold">SUNLIGHT</span>
            </div>
            Palms can resists in full sunlight but too much exposure might cause drying of leaves. It is 
            recommended to put it in indirect sunlight or bright sunlight to maintain its fresh leaves.<br><hr>
            <div style="display:flex">
              <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
              <span style="font-weight:bold">WATER</span>
            </div>
            Water only when the topmost soil is dry, Also do misting of water as needed to remove dirts.
          </mat-expansion-panel>
        </mat-accordion>
          <!-- <mat-card-actions>
            <button mat-button>LIKE</button>
            <button mat-button>SHARE</button>
          </mat-card-actions> -->
        </mat-card>
  </div>
  </div>
  <div class="row p-t-30">
    <div class="col-sm-4">
      <mat-card class="example-card">
          <mat-card-header>
            <!-- <div mat-card-avatar class="example-header-image"></div> -->
            <mat-card-title><h4>Katuray</h4></mat-card-title>
            <mat-card-subtitle><h6>Medicinal Plant</h6></mat-card-subtitle>
          </mat-card-header>
          <img mat-card-image src="assets/on-the-shop/katuray001.jpg">
          <mat-card-content>
            <table>
              <tr>
                <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
                <td width="65%"><span> <h6><b>KATURAY001</b></h6> </span></td>
                <td width="35%">
                  <p><span class="badge-stock">10⁺ Items available</span></p>
                </td>
              </tr>
              <tr>
                <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
                <td><span> <h6><b>50.00</b></h6> </span></td>
              </tr>
              <tr>
                <td><span>Benefits:</span></td>
                <td></td>
              </tr>
              <tr>
                <td><mat-icon class="c-success">done</mat-icon></td>
                <td colspan="2"><span>Medicinal Plant</span></td>
              </tr>
              <tr>
                <td><mat-icon class="c-success">done</mat-icon></td>
                <td colspan="2"><span>Flowering tree.</span></td>
              </tr>
              <tr>
                <td><mat-icon class="c-success">done</mat-icon></td>
                <td colspan="2"><span>Helps lower blood pressure.</span></td>
              </tr>
              <tr>
                <td><mat-icon class="c-success">done</mat-icon></td>
                <td colspan="2"><span>Safe for pets.</span></td>
              </tr>
            </table>
          </mat-card-content>
          <mat-accordion style="border:none;box-shadow: none;">
            <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
              </mat-panel-title>
              <mat-panel-description>
                <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
                <span>Plant Care Tips!</span>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div style="display:flex">
              <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
              <span style="font-weight:bold">SOIL</span>
            </div>
            This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
            <div style="display:flex">
              <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
              <span style="font-weight:bold">SUNLIGHT</span>
            </div>
            Katuray can grow indirect or direct sunlight.<br><hr>
            <div style="display:flex">
              <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
              <span style="font-weight:bold">WATER</span>
            </div>
            Water at least 3 times a week or as needed.
          </mat-expansion-panel>
        </mat-accordion>
          <!-- <mat-card-actions>
            <button mat-button>LIKE</button>
            <button mat-button>SHARE</button>
          </mat-card-actions> -->
        </mat-card>
  </div>
  <div class="col-sm-4">
      <mat-card class="example-card">
          <mat-card-header>
            <!-- <div mat-card-avatar class="example-header-image"></div> -->
            <mat-card-title><h4>Forget Me Not</h4></mat-card-title>
            <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
          </mat-card-header>
          <img mat-card-image src="assets/on-the-shop/forgetmn001.jpg">
          <mat-card-content>
            <table>
              <tr>
                <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
                <td width="65%"><span> <h6><b>FORGETMN001</b></h6> </span></td>
                <td width="35%">
                  <p><span class="badge-limited">Limited Stocks</span></p>
                </td>
              </tr>
              <tr>
                <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
                <td><span> <h6><b>350.00</b></h6> </span></td>
              </tr>
              <tr>
                <td><span>Benefits:</span></td>
                <td></td>
              </tr>
              <tr>
                <td><mat-icon class="c-success">done</mat-icon></td>
                <td colspan="2"><span>Ornamental plant for outdoors.</span></td>
              </tr>
              <tr>
                <td><mat-icon class="c-success">done</mat-icon></td>
                <td colspan="2"><span>Ideal Houseplant because of its beautiful flower.</span></td>
              </tr>
              <tr>
                <td><mat-icon class="c-success">done</mat-icon></td>
                <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
              </tr>
              <tr>
                <td><mat-icon class="c-success">done</mat-icon></td>
                <td colspan="2"><span>Safe for pets.</span></td>
              </tr>
            </table>
          </mat-card-content>
          <mat-accordion style="border:none;box-shadow: none;">
            <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
              </mat-panel-title>
              <mat-panel-description>
                <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
                <span>Plant Care Tips!</span>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div style="display:flex">
              <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
              <span style="font-weight:bold">SOIL</span>
            </div>
            This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
            <div style="display:flex">
              <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
              <span style="font-weight:bold">SUNLIGHT</span>
            </div>
            Place in indirect sunlight part of your home to maintain the good condition of leaves and flower.<br><hr>
            <div style="display:flex">
              <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
              <span style="font-weight:bold">WATER</span>
            </div>
            Water at least once a week or as needed.
          </mat-expansion-panel>
        </mat-accordion>
          <!-- <mat-card-actions>
            <button mat-button>LIKE</button>
            <button mat-button>SHARE</button>
          </mat-card-actions> -->
        </mat-card>
  </div>
  <div class="col-sm-4">
    <mat-card class="example-card">
        <mat-card-header>
          <!-- <div mat-card-avatar class="example-header-image"></div> -->
          <mat-card-title><h4>Summer Sunset Asiaticum</h4></mat-card-title>
          <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
        </mat-card-header>
        <img mat-card-image src="assets/on-the-shop/asiaticum001.jpg">
        <mat-card-content>
          <table>
            <tr>
              <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
              <td width="65%"><span> <h6><b>ASIATICUM001</b></h6> </span></td>
              <td width="35%">
                <p><span class="badge-limited">Limited Stocks</span></p>
              </td>
            </tr>
            <tr>
              <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
              <td><span> <h6><b>250.00</b></h6> </span></td>
            </tr>
            <tr>
              <td><span>Benefits:</span></td>
              <td></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Trailing plant for your home.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Ideal Hanging plant.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Safe for pets.</span></td>
            </tr>
          </table>
        </mat-card-content>
        <mat-accordion style="border:none;box-shadow: none;">
          <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
            </mat-panel-title>
            <mat-panel-description>
              <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
              <span>Plant Care Tips!</span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SOIL</span>
          </div>
          Can use Coco peat with Vermicast or loam soil as media.<br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SUNLIGHT</span>
          </div>
          This plant wants sunlight, you can place it even in direct sunlight. <br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">WATER</span>
          </div>
          Water at least thrice a week, Also do misting of water as needed to remove dirts.
        </mat-expansion-panel>
      </mat-accordion>
        <!-- <mat-card-actions>
          <button mat-button>LIKE</button>
          <button mat-button>SHARE</button>
        </mat-card-actions> -->
      </mat-card>
</div>
</div>
<div class="row p-t-30">
  <div class="col-sm-4">
    <mat-card class="example-card">
        <mat-card-header>
          <!-- <div mat-card-avatar class="example-header-image"></div> -->
          <mat-card-title><h4>Variegated Alpinia Vittata</h4></mat-card-title>
          <mat-card-subtitle><h6>Tropical Plant</h6></mat-card-subtitle>
        </mat-card-header>
        <img mat-card-image src="assets/on-the-shop/vittata001.jpg">
        <mat-card-content>
          <table>
            <tr>
              <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
              <td width="65%"><span> <h6><b>VITTATA001</b></h6> </span></td>
              <td width="35%">
                <p><span class="badge-stock">10⁺ Items available</span></p>
              </td>
            </tr>
            <tr>
              <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
              <td><span> <h6><b>150.00</b></h6> </span></td>
            </tr>
            <tr>
              <td><span>Benefits:</span></td>
              <td></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Natural air purifier.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Improves air quality.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Safe for pets.</span></td>
            </tr>
          </table>
        </mat-card-content>
        <mat-accordion style="border:none;box-shadow: none;">
          <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
            </mat-panel-title>
            <mat-panel-description>
              <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
              <span>Plant Care Tips!</span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SOIL</span>
          </div>
          This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SUNLIGHT</span>
          </div>
          Alpinia Vittata can grow both indirect and direct sunlight, but too much sun exposure may reduce its variegation.<br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">WATER</span>
          </div>
          Water at least thrice a week, Also do misting of water as needed to remove dirts.
        </mat-expansion-panel>
      </mat-accordion>
        <!-- <mat-card-actions>
          <button mat-button>LIKE</button>
          <button mat-button>SHARE</button>
        </mat-card-actions> -->
      </mat-card>
</div>
<div class="col-sm-4">
    <mat-card class="example-card">
        <mat-card-header>
          <!-- <div mat-card-avatar class="example-header-image"></div> -->
          <mat-card-title><h4>Andromeda</h4></mat-card-title>
          <mat-card-subtitle><h6>Tropical Plant</h6></mat-card-subtitle>
        </mat-card-header>
        <img mat-card-image src="assets/on-the-shop/andromeda001.jpg">
        <mat-card-content>
          <table>
            <tr>
              <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
              <td width="65%"><span> <h6><b>ANDROMEDA001</b></h6> </span></td>
              <td width="35%">
                <p><span class="badge-stock">5⁺ Items available</span></p>
              </td>
            </tr>
            <tr>
              <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
              <td><span> <h6><b>150.00</b></h6> </span></td>
            </tr>
            <tr>
              <td><span>Benefits:</span></td>
              <td></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Natural air purifier.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Improves air quality.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Safe for pets.</span></td>
            </tr>
          </table>
        </mat-card-content>
        <mat-accordion style="border:none;box-shadow: none;">
          <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
            </mat-panel-title>
            <mat-panel-description>
              <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
              <span>Plant Care Tips!</span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SOIL</span>
          </div>
          This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SUNLIGHT</span>
          </div>
          This plant can grow both indirect and direct sunlight.<br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">WATER</span>
          </div>
          Water at least thrice a week, Also do misting of water as needed to remove dirts.
        </mat-expansion-panel>
      </mat-accordion>
        <!-- <mat-card-actions>
          <button mat-button>LIKE</button>
          <button mat-button>SHARE</button>
        </mat-card-actions> -->
      </mat-card>
</div>
<div class="col-sm-4">
  <mat-card class="example-card">
      <mat-card-header>
        <!-- <div mat-card-avatar class="example-header-image"></div> -->
        <mat-card-title><h4>Lady di</h4></mat-card-title>
        <mat-card-subtitle><h6>Tropical Plant</h6></mat-card-subtitle>
      </mat-card-header>
      <img mat-card-image src="assets/on-the-shop/ladydi001.jpg">
      <mat-card-content>
        <table>
          <tr>
            <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
            <td width="65%"><span> <h6><b>LADYDI001</b></h6> </span></td>
            <td width="35%">
              <p><span class="badge-stock">5⁺ Items available</span></p>
            </td>
          </tr>
          <tr>
            <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
            <td><span> <h6><b>150.00</b></h6> </span></td>
          </tr>
          <tr>
            <td><span>Benefits:</span></td>
            <td></td>
          </tr>
          <tr>
            <td><mat-icon class="c-success">done</mat-icon></td>
            <td colspan="2"><span>Natural air purifier.</span></td>
          </tr>
          <tr>
            <td><mat-icon class="c-success">done</mat-icon></td>
            <td colspan="2"><span>Improves air quality.</span></td>
          </tr>
          <tr>
            <td><mat-icon class="c-success">done</mat-icon></td>
            <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
          </tr>
          <tr>
            <td><mat-icon class="c-success">done</mat-icon></td>
            <td colspan="2"><span>Safe for pets.</span></td>
          </tr>
        </table>
      </mat-card-content>
      <mat-accordion style="border:none;box-shadow: none;">
        <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
          </mat-panel-title>
          <mat-panel-description>
            <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
            <span>Plant Care Tips!</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div style="display:flex">
          <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
          <span style="font-weight:bold">SOIL</span>
        </div>
        This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
        <div style="display:flex">
          <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
          <span style="font-weight:bold">SUNLIGHT</span>
        </div>
        This plant can grow both indirect and direct sunlight.<br><hr>
        <div style="display:flex">
          <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
          <span style="font-weight:bold">WATER</span>
        </div>
        Water at least thrice a week, Also do misting of water as needed to remove dirts.
      </mat-expansion-panel>
    </mat-accordion>
      <!-- <mat-card-actions>
        <button mat-button>LIKE</button>
        <button mat-button>SHARE</button>
      </mat-card-actions> -->
    </mat-card>
</div>
</div>
<div class="row p-t-30">
  <div class="col-sm-4">
    <mat-card class="example-card">
        <mat-card-header>
          <!-- <div mat-card-avatar class="example-header-image"></div> -->
          <mat-card-title><h4>Calathea Lutea</h4></mat-card-title>
          <mat-card-subtitle><h6>Tropical Plant</h6></mat-card-subtitle>
        </mat-card-header>
        <img mat-card-image src="assets/on-the-shop/lutea001.jpg">
        <mat-card-content>
          <table>
            <tr>
              <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
              <td width="65%"><span> <h6><b>LUTEA001</b></h6> </span></td>
              <td width="35%">
                <p><span class="badge-limited">Limited Stocks</span></p>
              </td>
            </tr>
            <tr>
              <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
              <td><span> <h6><b>150.00</b></h6> </span></td>
            </tr>
            <tr>
              <td><span>Benefits:</span></td>
              <td></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Natural air purifier.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Improves air quality.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Safe for pets.</span></td>
            </tr>
          </table>
        </mat-card-content>
        <mat-accordion style="border:none;box-shadow: none;">
          <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
            </mat-panel-title>
            <mat-panel-description>
              <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
              <span>Plant Care Tips!</span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SOIL</span>
          </div>
          This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SUNLIGHT</span>
          </div>
          Recommended to place in indirect sunlight to maintain its fresh green leaves. also, Calathea lutea can also grow direct sunlight. <br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">WATER</span>
          </div>
          Water at least thrice a week or as needed, Also do misting of water as needed to remove dirts.
        </mat-expansion-panel>
      </mat-accordion>
        <!-- <mat-card-actions>
          <button mat-button>LIKE</button>
          <button mat-button>SHARE</button>
        </mat-card-actions> -->
      </mat-card>
</div>
<div class="col-sm-4">
    <mat-card class="example-card">
        <mat-card-header>
          <!-- <div mat-card-avatar class="example-header-image"></div> -->
          <mat-card-title><h4>Calathea Lutea</h4></mat-card-title>
          <mat-card-subtitle><h6>Tropical Plant</h6></mat-card-subtitle>
        </mat-card-header>
        <img mat-card-image src="assets/on-the-shop/lutea002.jpg">
        <mat-card-content>
          <table>
            <tr>
              <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
              <td width="65%"><span> <h6><b>LUTEA002</b></h6> </span></td>
              <td width="35%">
                <p><span class="badge-limited">Limited Stocks</span></p>
              </td>
            </tr>
            <tr>
              <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
              <td><span> <h6><b>200.00</b></h6> </span></td>
            </tr>
            <tr>
              <td><span>Benefits:</span></td>
              <td></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Natural air purifier.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Improves air quality.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Safe for pets.</span></td>
            </tr>
          </table>
        </mat-card-content>
        <mat-accordion style="border:none;box-shadow: none;">
          <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
            </mat-panel-title>
            <mat-panel-description>
              <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
              <span>Plant Care Tips!</span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SOIL</span>
          </div>
          This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SUNLIGHT</span>
          </div>
          Recommended to place in indirect sunlight to maintain its fresh green leaves. also, Calathea lutea can also grow direct sunlight.<br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">WATER</span>
          </div>
          Water at least thrice a week or as needed, Also do misting of water as needed to remove dirts.
        </mat-expansion-panel>
      </mat-accordion>
        <!-- <mat-card-actions>
          <button mat-button>LIKE</button>
          <button mat-button>SHARE</button>
        </mat-card-actions> -->
      </mat-card>
</div>
<div class="col-sm-4">
  <mat-card class="example-card">
      <mat-card-header>
        <!-- <div mat-card-avatar class="example-header-image"></div> -->
        <mat-card-title><h4>Amaryllis Punicium</h4></mat-card-title>
        <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
      </mat-card-header>
      <img mat-card-image src="assets/on-the-shop/punicium001.jpg">
      <mat-card-content>
        <table>
          <tr>
            <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
            <td width="65%"><span> <h6><b>PUNICIUM001</b></h6> </span></td>
            <td width="35%">
              <p><span class="badge-stock">3⁺ Items available</span></p>
            </td>
          </tr>
          <tr>
            <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
            <td><span> <h6><b>200.00</b></h6> </span></td>
          </tr>
          <tr>
            <td><span>Benefits:</span></td>
            <td></td>
          </tr>
          <tr>
            <td><mat-icon class="c-success">done</mat-icon></td>
            <td colspan="2"><span>Ideal Ornamental plant at home.</span></td>
          </tr>
          <tr>
            <td><mat-icon class="c-success">done</mat-icon></td>
            <td colspan="2"><span>Can also place indoors as Ornaments.</span></td>
          </tr>
          <tr>
            <td><mat-icon class="c-success">done</mat-icon></td>
            <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
          </tr>
          <tr>
            <td><mat-icon class="c-success">done</mat-icon></td>
            <td colspan="2"><span>Safe for pets.</span></td>
          </tr>
        </table>
      </mat-card-content>
      <mat-accordion style="border:none;box-shadow: none;">
        <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
          </mat-panel-title>
          <mat-panel-description>
            <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
            <span>Plant Care Tips!</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div style="display:flex">
          <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
          <span style="font-weight:bold">SOIL</span>
        </div>
        This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
        <div style="display:flex">
          <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
          <span style="font-weight:bold">SUNLIGHT</span>
        </div>
        Can grow in both direct and indirect sunlight.<br><hr>
        <div style="display:flex">
          <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
          <span style="font-weight:bold">WATER</span>
        </div>
        Water at least twice a week or as needed.
      </mat-expansion-panel>
    </mat-accordion>
      <!-- <mat-card-actions>
        <button mat-button>LIKE</button>
        <button mat-button>SHARE</button>
      </mat-card-actions> -->
    </mat-card>
</div>
</div>
<div class="row p-t-30">
  <div class="col-sm-4">
    <mat-card class="example-card">
        <mat-card-header>
          <!-- <div mat-card-avatar class="example-header-image"></div> -->
          <mat-card-title><h4>Zigzag Plant</h4></mat-card-title>
          <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
        </mat-card-header>
        <img mat-card-image src="assets/on-the-shop/zigzag001.jpg">
        <mat-card-content>
          <table>
            <tr>
              <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
              <td width="65%"><span> <h6><b>ZIGZAG001</b></h6> </span></td>
              <td width="35%">
                <p><span class="badge-limited">Limited Stocks</span></p>
              </td>
            </tr>
            <tr>
              <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
              <td><span> <h6><b>100.00</b></h6> </span></td>
            </tr>
            <tr>
              <td><span>Benefits:</span></td>
              <td></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Ideal Ornamental plant for your home.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Can place indoors, and low maintenance.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Safe for pets.</span></td>
            </tr>
          </table>
        </mat-card-content>
        <mat-accordion style="border:none;box-shadow: none;">
          <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
            </mat-panel-title>
            <mat-panel-description>
              <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
              <span>Plant Care Tips!</span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SOIL</span>
          </div>
          This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SUNLIGHT</span>
          </div>
          Recommended to place in indirect sunlight part of your home.<br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">WATER</span>
          </div>
          Water at least twice a week or as needed.
        </mat-expansion-panel>
      </mat-accordion>
        <!-- <mat-card-actions>
          <button mat-button>LIKE</button>
          <button mat-button>SHARE</button>
        </mat-card-actions> -->
      </mat-card>
</div>
<div class="col-sm-4">
    <mat-card class="example-card">
        <mat-card-header>
          <!-- <div mat-card-avatar class="example-header-image"></div> -->
          <mat-card-title><h4>Zigzag Plant</h4></mat-card-title>
          <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
        </mat-card-header>
        <img mat-card-image src="assets/on-the-shop/zigzag002.jpg">
        <mat-card-content>
          <table>
            <tr>
              <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
              <td width="65%"><span> <h6><b>ZIGZAG002</b></h6> </span></td>
              <td width="35%">
                <p><span class="badge-limited">Limited Stocks</span></p>
              </td>
            </tr>
            <tr>
              <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
              <td><span> <h6><b>150.00</b></h6> </span></td>
            </tr>
            <tr>
              <td><span>Benefits:</span></td>
              <td></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Ideal Ornamental plant for your home.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Can place indoors, and low maintenance.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Safe for pets.</span></td>
            </tr>
          </table>
        </mat-card-content>
        <mat-accordion style="border:none;box-shadow: none;">
          <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
            </mat-panel-title>
            <mat-panel-description>
              <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
              <span>Plant Care Tips!</span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SOIL</span>
          </div>
          This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SUNLIGHT</span>
          </div>
          Recommended to place in indirect sunlight part of your home.<br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">WATER</span>
          </div>
          Water at least twice a week or as needed.
        </mat-expansion-panel>
      </mat-accordion>
        <!-- <mat-card-actions>
          <button mat-button>LIKE</button>
          <button mat-button>SHARE</button>
        </mat-card-actions> -->
      </mat-card>
</div>
<div class="col-sm-4">
  <mat-card class="example-card">
      <mat-card-header>
        <!-- <div mat-card-avatar class="example-header-image"></div> -->
        <mat-card-title><h4>Zigzag Plant</h4></mat-card-title>
        <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
      </mat-card-header>
      <img mat-card-image src="assets/on-the-shop/zigzag003.jpg">
      <mat-card-content>
        <table>
          <tr>
            <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
            <td width="65%"><span> <h6><b>ZIGZAG003</b></h6> </span></td>
            <td width="35%">
              <p><span class="badge-limited">Limited Stocks</span></p>
            </td>
          </tr>
          <tr>
            <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
            <td><span> <h6><b>150.00</b></h6> </span></td>
          </tr>
          <tr>
            <td><span>Benefits:</span></td>
            <td></td>
          </tr>
          <tr>
            <td><mat-icon class="c-success">done</mat-icon></td>
            <td colspan="2"><span>Ideal Ornamental plant for your home.</span></td>
          </tr>
          <tr>
            <td><mat-icon class="c-success">done</mat-icon></td>
            <td colspan="2"><span>Can place indoors, and low maintenance.</span></td>
          </tr>
          <tr>
            <td><mat-icon class="c-success">done</mat-icon></td>
            <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
          </tr>
          <tr>
            <td><mat-icon class="c-success">done</mat-icon></td>
            <td colspan="2"><span>Safe for pets.</span></td>
          </tr>
        </table>
      </mat-card-content>
      <mat-accordion style="border:none;box-shadow: none;">
        <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
          </mat-panel-title>
          <mat-panel-description>
            <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
            <span>Plant Care Tips!</span>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div style="display:flex">
          <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
          <span style="font-weight:bold">SOIL</span>
        </div>
        This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
        <div style="display:flex">
          <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
          <span style="font-weight:bold">SUNLIGHT</span>
        </div>
        Recommended to place in indirect sunlight part of your home.<br><hr>
        <div style="display:flex">
          <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
          <span style="font-weight:bold">WATER</span>
        </div>
        Water at least twice a week or as needed.
      </mat-expansion-panel>
    </mat-accordion>
      <!-- <mat-card-actions>
        <button mat-button>LIKE</button>
        <button mat-button>SHARE</button>
      </mat-card-actions> -->
    </mat-card>
</div>
</div>
<div class="row p-t-30">
  <div class="col-sm-4">
    <mat-card class="example-card">
        <mat-card-header>
          <!-- <div mat-card-avatar class="example-header-image"></div> -->
          <mat-card-title><h4>Variegated Ribbon Grass</h4></mat-card-title>
          <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
        </mat-card-header>
        <img mat-card-image src="assets/on-the-shop/ribbon001.jpg">
        <mat-card-content>
          <table>
            <tr>
              <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
              <td width="65%"><span> <h6><b>RIBBON001</b></h6> </span></td>
              <td width="35%">
                <p><span class="badge-limited">Limited Stocks</span></p>
              </td>
            </tr>
            <tr>
              <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
              <td><span> <h6><b>100.00</b></h6> </span></td>
            </tr>
            <tr>
              <td><span>Benefits:</span></td>
              <td></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Ideal Ornamental plant for your home.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Low maintenance.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Safe for pets.</span></td>
            </tr>
          </table>
        </mat-card-content>
        <mat-accordion style="border:none;box-shadow: none;">
          <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
            </mat-panel-title>
            <mat-panel-description>
              <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
              <span>Plant Care Tips!</span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SOIL</span>
          </div>
          This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SUNLIGHT</span>
          </div>
          Ribbon grass can grow both direct and indirect sunlight.<br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">WATER</span>
          </div>
          Water at least twice a week.
        </mat-expansion-panel>
      </mat-accordion>
        <!-- <mat-card-actions>
          <button mat-button>LIKE</button>
          <button mat-button>SHARE</button>
        </mat-card-actions> -->
      </mat-card>
</div>
<div class="col-sm-4">
    <mat-card class="example-card">
        <mat-card-header>
          <!-- <div mat-card-avatar class="example-header-image"></div> -->
          <mat-card-title><h4>Variegated Ribbon Grass</h4></mat-card-title>
          <mat-card-subtitle><h6>Ornamental Plant</h6></mat-card-subtitle>
        </mat-card-header>
        <img mat-card-image src="assets/on-the-shop/ribbon002.jpg">
        <mat-card-content>
          <table>
            <tr>
              <td width="10%"><mat-icon class="c-default" matTooltip="Item Code" aria-hidden="false" aria-label="Example home icon">local_mall</mat-icon></td>
              <td width="65%"><span> <h6><b>RIBBON002</b></h6> </span></td>
              <td width="35%">
                <p><span class="badge-limited">Limited Stocks</span></p>
              </td>
            </tr>
            <tr>
              <td><mat-icon class="c-default" matTooltip="Price" aria-hidden="false" aria-label="Example home icon">local_offer</mat-icon></td>
              <td><span> <h6><b>100.00</b></h6> </span></td>
            </tr>
            <tr>
              <td><span>Benefits:</span></td>
              <td></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Ideal Ornamental plant for your home.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Low maintenance.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Brings fresh ambiance to your home.</span></td>
            </tr>
            <tr>
              <td><mat-icon class="c-success">done</mat-icon></td>
              <td colspan="2"><span>Safe for pets.</span></td>
            </tr>
          </table>
        </mat-card-content>
        <mat-accordion style="border:none;box-shadow: none;">
          <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
            </mat-panel-title>
            <mat-panel-description>
              <mat-icon style="color:gray;margin-right:5px;">local_florist</mat-icon>
              <span>Plant Care Tips!</span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SOIL</span>
          </div>
          This plant can grow in different kinds of soil but make sure you will use a well drained soil.<br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">SUNLIGHT</span>
          </div>
          Ribbon grass can grow both direct and indirect sunlight.<br><hr>
          <div style="display:flex">
            <mat-icon style="color:gray;margin-right:5px;">favorite_border</mat-icon>
            <span style="font-weight:bold">WATER</span>
          </div>
          Water at least twice a week.
        </mat-expansion-panel>
      </mat-accordion>
        <!-- <mat-card-actions>
          <button mat-button>LIKE</button>
          <button mat-button>SHARE</button>
        </mat-card-actions> -->
      </mat-card>
</div>
<div class="col-sm-4"></div>
</div>
    </div>
</body>
